import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle34624559 = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 36, height: 36, viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 35, height: 35, rx: 7.5, fill: "white", stroke: "#5F6770" }));
const ForwardRef = forwardRef(SvgRectangle34624559);
export { ForwardRef as ReactComponent };
